import client from "../../client/client";

class CoverageDocumentService {
	getFormats(cancelToken) {
		return client.get("/coverage-document/formats", { config: { cancelToken } });
	}

	getTypes(cancelToken) {
		return client.get("/coverage-document/types", { config: { cancelToken } });
	}

	getAll({ projectId }, cancelToken) {
		return client.get(`/coverage-document/projects/${projectId}`, { config: { cancelToken } });
	}

	create(
		{ projectId },
		{ name = "", ref = "", ownerId = "", type = "", format = "", phaseId = "", thematics = [], ...rest } = {},
		cancelToken
	) {
		return client.post(`/coverage-document/projects/${projectId}`, {
			payload: { name, ref, ownerId, type, format, phaseId, thematics, ...rest },
			config: { cancelToken },
		});
	}

	update({ docId }, payload = {}, cancelToken) {
		const cleanPayload = Object.fromEntries(Object.entries(payload).filter(([, v]) => v !== "" && v !== undefined));
		return client.patch(`/coverage-document/${docId}`, {
			payload: cleanPayload,
			config: { cancelToken },
		});
	}

	updateBatch(payload, cancelToken) {
		return client.patch("/coverage-document", { payload, config: { cancelToken } });
	}

	delete({ docId }, cancelToken) {
		return client.delete(`/coverage-document/${docId}`, { config: { cancelToken } });
	}

	getImportTemplate({ projectId }, cancelToken) {
		return client.get(`/coverage-document/projects/${projectId}/import`, { config: { cancelToken } });
	}

	getImportTemplateFile({ projectId }, cancelToken) {
		return client.get(`/coverage-document/projects/${projectId}/import-file`, {
			config: {
				cancelToken,
				responseType: "blob",
			},
		});
	}

	import({ projectId }, file, shouldErase, cancelToken) {
		return client.upload(`/coverage-document/projects/${projectId}/import`, file, {
			payload: shouldErase,
			config: { cancelToken },
		});
	}

	getDeliverablesByCatFilter({ projectId }, payload, cancelToken, { page = 0, limit = 10, sort = "id,asc" } = {}) {
		return client.post(`/coverage-document/projects/${projectId}/search`, {
			payload,
			params: { page, limit, sort },
			config: { cancelToken },
		});
	}

	getDeliverableCount({ projectId }, cancelToken) {
		return client.get(`/coverage-document/projects/${projectId}/counter`, {
			config: { cancelToken },
		});
	}

	existsByProjectAndRef({ projectId }, { ref }, cancelToken) {
		return client.get(`/coverage-document/projects/${projectId}/check-duplicates-ref`, {
			params: { ref },
			config: { cancelToken },
		});
	}

	existsByProjectAndName({ projectId }, { name }, cancelToken) {
		return client.get(`/coverage-document/projects/${projectId}/check-duplicates-name`, {
			params: { name },
			config: { cancelToken },
		});
	}
}

export default new CoverageDocumentService();
